<div
  fxLayout="row"
  fxLayoutGap="30px"
  fxLayoutAlign="space-around stretch"
  appMargin
  marginB="5"
>
  <div fxFlex="25%">
    <app-dashboard-invoice></app-dashboard-invoice>
  </div>
  <div fxFlex="grow">
    <div fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="30px">
      <div fxFlex="grow">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div
            fxLayoutAlign="start center"
            fxLayout="row"
            fxLayoutGap="20px"
            (click)="goBack()"
            class="link"
          >
            <div>
              <img src="assets/icons/left-arrow-icon.svg" alt="" />
            </div>
            <div class="equipment-id">
              <span>Home/ Application</span>
              <h2 class="ui primary header">Applications</h2>
            </div>
          </div>
        </div>
        <div class="ui divider" appMargin marginY="3"></div>
        <div class="ui basic segment" *ngIf="apps && apps.length < 1">
          <app-no-record-found
            message="You do not have access to any application"
          ></app-no-record-found>
        </div>
        <div
          class="ui segment"
          id="wrapper"
          appPadding="0"
          *ngFor="
            let app of apps;
            let i = index;
            let even = even;
            let odd = odd
          "
        >
          <div
            fxFlex
            class="ui basic segment"
            id="inner"
            fxLayoutAlign="start center"
            fxLayout="row"
            appPadding="10px"
            style="min-height: 100%"
          >
            <div fxFlex="5%">
              <div
                class="ui circular big label app-initial"
                [style.background]="app.color"
              >
                {{ app?.applicationName | truncate: 1:false }}
              </div>
            </div>
            <div fxFlex="grow">
              <h3 appMargin marginB="4px" class="ui primary header">
                {{ app?.applicationName }}
              </h3>
              <p class="description">{{ app?.applicationDescription }}</p>
            </div>
            <div fxFlex="20%">
              <a
                class="ui large label text-right"
                href="{{ baseUrl }}/identity/continue/?return_url={{
                  app?.applicationHost
                }}"
                target="_blank"
              >
                Go to Application
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
